/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { catchError, of, throwError } from 'rxjs';
import { DebugService } from 'src/app/services/debug.service';
import { RequestService } from 'src/chatbot/service/request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'chat-bot-info',
  standalone: true,
  imports: [ CommonModule, ReactiveFormsModule, TranslateModule ],
  templateUrl: './sendMail.component.html',
  styleUrl: './sendMail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendMailComponent {
    private debugService = inject(DebugService);
    
    private requestService = inject(RequestService)
    private modalController = inject(ModalController);
    public formBuilder = inject(FormBuilder);
    public sendChat: FormGroup;
    public sendingMail = signal(false);
    public translate = inject(TranslateService);
    public errorMail = signal(false);

    constructor() {
      this.sendChat = this.formBuilder.group({ 
        email: ['', [Validators.required, Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]]
      });
    }

    closeModal(){
        this.modalController.dismiss();
    }

    resetError(){
      this.errorMail.set(false)
    }

    sendMail(){
      if (this.sendChat.invalid) {
        this.errorMail.set(true);
        this.debugService.error('invalid form', '[SendMailComponent]');
        return;
      }
      this.errorMail.set(false);
      this.sendingMail.set(true);
      const email: string = this.sendChat.get('email')?.value.trim();
      const name = null;

      this.requestService.saveChat(email, name)
        .pipe(
          catchError((err: Error) => {
            this.debugService.error(err, '[SendMailComponent] Error Saving Chat');
            this.sendingMail.set(false);
            Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Ha ocurrido un error al enviar la conversación`) });
            return throwError(() => new Error('HTTP request failed', { cause: err }));
          })
        )
        .subscribe((res) => {
          this.debugService.debug(res, '[SendMailComponent] Saving Chat API Response');
          this.sendingMail.set(false);
          if (res.status === 'Ok'){
            Swal.fire({
              title: '',
              text: this.translate.instant(`Su conversación ha sido enviada`),
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK',
              timer: 2500,
              timerProgressBar: true,
            })
            this.modalController.dismiss();
            return;
          }
          Swal.fire({ icon: 'error', title: '', text: this.translate.instant(`Ha ocurrido un error al enviar la conversación`) });
        });
      }

 }
